import React from 'react';
import classNames from 'classnames';

import { copy } from '@store/FooterData';

import * as styles from './Copy.module.scss';

export const Copy: React.FC = () => {
	return (
		<p
			className={classNames(styles.copyright, 'font-10')}
			dangerouslySetInnerHTML={{ __html: copy.description }}
		/>
	);
};
